import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSegmentTrack } from '@application/hooks/useSegment/useSegment';
import { Tooltip } from '@abtasty/design-system';
import styles from './HelperLink.module.scss';

export const HelperLink: FC = () => {
  const { t } = useTranslation();
  const tooltipText = t('Open support article');
  const sendTracking = useSegmentTrack();
  return (
    <Tooltip content={tooltipText} placement="bottom">
      <a
        aria-label={tooltipText}
        className={styles.faq}
        href="https://abtasty.zendesk.com/hc/en-us/articles/4711314651804-QA-QA-Assistant#h_01G9CS4JSVJA2E993NJ8ZMCXCZ "
        target="_blank"
        rel="noreferrer noopener"
        onClick={() => sendTracking('Qa - Click on help')}
      >
        ?
      </a>
    </Tooltip>
  );
};
